export type Case = {
  id: string
  name: string
  bgSchool: string
  bgGpa: string
  bgLang: string
  offers: string[]
  major: string
  avatar: string
}

export const cases: Case[] = [
  {
    id: 'c1',
    name: '陈同学',
    bgSchool: '上海交通大学',
    bgGpa: 'GPA 3.8/4.0',
    bgLang: '雅思 7.5',
    offers: ['帝国理工学院', '伦敦大学学院'],
    major: '计算机科学',
    avatar:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200',
  },
  {
    id: 'c2',
    name: '王同学',
    bgSchool: '武汉大学',
    bgGpa: 'GPA 3.6/4.0',
    bgLang: '托福 105',
    offers: ['哥伦比亚大学', '约翰霍普金斯'],
    major: '金融工程',
    avatar:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200',
  },
  {
    id: 'c3',
    name: '李同学',
    bgSchool: '中山大学',
    bgGpa: 'GPA 3.7/4.0',
    bgLang: '雅思 7.0',
    offers: ['新加坡国立大学', '香港大学'],
    major: '商业分析',
    avatar:
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200',
  },
]
